import React from 'react';

import { Screen, withScreen, createScreenRoute } from '@gogame/screens';

import LabelsDataTable from './components/LabelsDataTable';
import { labelsLink, labelsSearchParams } from './navigation';
import labelsReducer from './screenReducer';

const id = 12;
const permission = 37;

const Labels = withScreen({
  name: 'labels',
  searchParams: labelsSearchParams,
  reducer: labelsReducer,
})(() => {
  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <LabelsDataTable />
      </Screen.Body>
    </React.Fragment>
  );
});

export default createScreenRoute({
  title: 'Labels',
  link: labelsLink,
  screen: <Labels />,
  id: id,
  permission: permission,
  knowledgeBaseUrl:
    'https://go-game.zendesk.com/hc/en-us/articles/360036046473-Labels',
});
